
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>


        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">ICD Info</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Distributor_Code">Current Distributor Code<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Distributor_Code" id="login-Distributor_Code" name="Distributor_Code" placeholder="Enter Distributor_Code" autocomplete="Distributor_Code"
                           class="form-control"
                           appAiHint="Distributor Code" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name"> Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name"> Corporation Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                           class="form-control"
                           appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">


                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>


                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>




              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">



                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>


                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-sm-4">

                  <div class="form-group">
                    <div class="col-md-12">

                      <label class="col-form-label " *ngIf="selectedCountry == 'US'" for="New_Location_out_state">Is new location out of state <code>*</code></label>
                      <label class="col-form-label " *ngIf="selectedCountry == 'Canada'" for="New_Location_out_state">Is new location out of province <code>*</code></label>
                      <select formControlName="New_Location_out_state" class="form-control" (change)="onChange_outofState($event)" [ngClass]="{ 'is-invalid': submitted && f.New_Location_out_state.errors }">
                        <option value="" disabled>Please Select</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                      <div *ngIf="submitted && f.New_Location_out_state.errors" class="invalid-feedback">
                        <div *ngIf="f.New_Location_out_state.errors.required">New location out of state  is required</div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="col-sm-4">

                  <div class="form-group">
                    <div class="col-md-12">
                      <label class="col-form-label " for="Is_storage_location">Is this a storage location	<code>*</code></label>
                      <select formControlName="Is_storage_location" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Is_storage_location.errors }">
                        <option value="" disabled>Please Select</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                      <div *ngIf="submitted && f.Is_storage_location.errors" class="invalid-feedback">
                        <div *ngIf="f.Is_storage_location.errors.required">storage location  is required</div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="col-sm-4">

                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N # (Tax ID)<code>*</code></label>
                    <div class="col-md-12">
                      <input type="text" formControlName="Tax_ID" id="login-Tax_ID" name="Tax_ID" placeholder="Enter Tax_ID" autocomplete="Tax_ID"
                             class="form-control" />

                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="selectedCountry == 'US'">

                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-State_UI_ID">State UI ID# (Required for CO/FL/MN/NY)</label>
                    <div class="col-md-12">
                      <input type="text" formControlName="State_UI_ID" id="login-State_UI_ID" name="State_UI_ID"
                             placeholder="Enter State_ID" autocomplete="State_ID"
                             class="form-control" [attr.maxlength]="fieldMaxLengths.State_UI_ID"
                             appAiHint="State UI ID" [aiHintForm]="icdForm" />
                      <div class="text-right small mt-1"
                           [ngClass]="{
       'text-danger': f.State_UI_ID.errors?.maxlength,
       'text-muted': !f.State_UI_ID.errors?.maxlength
     }">

                        {{ icdForm.get('State_UI_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.State_UI_ID }}

                      </div>
                      <div *ngIf="submitted && f.State_UI_ID.errors" class="invalid-feedback">

                        <div *ngIf="f.State_UI_ID.errors.maxlength">
                          Maximum {{ fieldMaxLengths.State_UI_ID }} characters allowed
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </div>


              <div class="row">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Address">Old Address <code>*</code></label>
                    <input type="text" formControlName="Company_Address" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Address.valid, 'is-invalid' : submitted && f.Company_Address.valid}" placeholder="Enter  Old_Address "
                           appAiHint="Company Address" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Address.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Address.errors.required">Company_Address   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Address_N">New Address to be Insured <code>*</code></label>
                    <input type="text" formControlName="Company_Address_N" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address_N"
                           [ngClass]="{'is-valid': f.Company_Address_N.valid, 'is-invalid' : submitted && !f.Company_Address_N.valid}" placeholder="Enter New_Address "
                           appAiHint="New Company Address" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{
       'text-danger': f.Company_Address_N.errors?.maxlength,
       'text-muted': !f.Company_Address_N.errors?.maxlength
     }">

                      {{ icdForm.get('Company_Address_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address_N }}

                    </div>
                    <div *ngIf="submitted && f.Company_Address_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Address_N.errors.required">New_Address   is required</div>
                      <div *ngIf="f.Company_Address_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Company_Address_N }} characters allowed
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Address2">Old Address 2<code>*</code></label>
                    <input type="text" formControlName="Company_Address2" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Address2.valid, 'is-invalid' : submitted && f.Company_Address2.valid}" placeholder="Enter  Old_Address "
                           appAiHint="Company Address 2" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Address2.errors.required">Old_Address   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Address2_N">New Address 2</label>
                    <input type="text" formControlName="Company_Address2_N" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address2_N"
                           placeholder="Enter New_Address_2 "
                           appAiHint="New Company Address 2" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{
                         'text-danger' : f.Company_Address2_N.errors?.maxlength,
                         'text-muted' : !f.Company_Address2_N.errors?.maxlength
                         }">
                      {{ icdForm.get('Company_Address2_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address2_N }}
                    </div>
                    <div *ngIf="submitted && f.Company_Address2_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Address2_N.errors.required">New_Addres_2s   is required</div>
                      <div *ngIf="f.Company_Address2_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Company_Address2_N }} characters allowed
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_City">Old City<code>*</code></label>
                    <input type="text" formControlName="Company_City" class="form-control"
                           [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && f.Company_City.valid}" placeholder="Enter  Old_City "
                           appAiHint="Company City" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_City.errors.required">Old_City   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_City_N">New City<code>*</code></label>
                    <input type="text" formControlName="Company_City_N" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_City_N"
                           [ngClass]="{'is-valid': f.Company_City_N.valid, 'is-invalid' : submitted && !f.Company_City_N.valid}" placeholder="Enter New_City "
                           appAiHint="New Company City" [aiHintForm]="icdForm" />
                    <div class="text-right
                         small mt-1"
                         [ngClass]="{
                         'text-danger' : f.Company_City_N.errors?.maxlength,
                          'text-muted' : !f.Company_City_N.errors?.maxlength
                          }">
                      {{ icdForm.get('Company_City_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_City_N }}
                    </div>
                    <div *ngIf="submitted && f.Company_City_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_City_N.errors.required">New_City   is required</div>
                      <div *ngIf="f.Company_City_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Company_City_N }} characters allowed
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row" *ngIf="selectedCountry == 'US'">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Country">Old County<code>*</code></label>
                    <input type="text" formControlName="Company_Country" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Country.valid, 'is-invalid' : submitted && f.Company_Country.valid}" placeholder="Enter  Old_County "
                           appAiHint="Company County" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Country.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Country.errors.required">Old_County   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Country_N">New County<code>*</code></label>
                    <input type="text" formControlName="Company_Country_N" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Country_N.valid, 'is-invalid' : submitted && !f.Company_Country_N.valid}" placeholder="Enter New_County "
                           appAiHint="New Company County" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Country_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Country_N.errors.required">New_County   is required</div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="row" *ngIf="selectedCountry == 'US'">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_State">Old State<code>*</code></label>
                    <input type="text" formControlName="Company_State" class="form-control"
                           [ngClass]="{'is-valid': f.Company_State.valid, 'is-invalid' : submitted && f.Company_State.valid}" placeholder="Enter  Old_State "
                           appAiHint="Company State" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_State.errors.required">Old_State   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_State_N">New State<code>*</code></label>


                    <ng-select [searchable]="true" (change)="onStateChange($event)" formControlName="Company_State_N" [ngClass]="{'is-valid': f.Company_State_N.valid, 'is-invalid' : submitted && !f.Company_State_N.valid}">
                      <ng-option *ngFor="let o of ddlUSStates"
                                 [value]="o.value">
                        {{ o.name }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Company_State_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_State_N.errors.required">New_State   is required</div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" *ngIf="selectedCountry == 'Canada'">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Province">Old Province<code>*</code></label>
                    <input type="text" formControlName="Company_Province" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Province.valid, 'is-invalid' : submitted && f.Company_Province.valid}" placeholder="Enter  Old_Province "
                           appAiHint="Company Province" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Province.errors.required">Old_Province   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Province_N">New Province<code>*</code></label>


                    <ng-select [searchable]="true" formControlName="Company_Province_N" [ngClass]="{'is-valid': f.Company_Province_N.valid, 'is-invalid' : submitted && !f.Company_Province_N.valid}">
                      <ng-option *ngFor="let o of ddlCAProvinence"
                                 [value]="o.value">
                        {{ o.name }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Company_Province_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Province_N.errors.required">New_Province   is required</div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="row">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Postal_Code">Old Postal Code<code>*</code></label>
                    <input type="text" formControlName="Company_Postal_Code" class="form-control"
                           [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && f.Company_Postal_Code.valid}" placeholder="Enter  Old_Postal_Code "
                           appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Postal_Code.errors.required">Old_Postal_Code   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Postal_Code_N">New PostalCode<code>*</code></label>
                    <input type="text" formControlName="Company_Postal_Code_N" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Postal_Code_N"
                           [ngClass]="{'is-valid': f.Company_Postal_Code_N.valid, 'is-invalid' : submitted && !f.Company_Postal_Code_N.valid}" placeholder="Enter New_Postal_Code "
                           appAiHint="New Company Postal Code" [aiHintForm]="icdForm" />
                    <div class="text-right
                          small mt-1"
                         [ngClass]="{
                          'text-danger' : f.Company_Postal_Code_N.errors?.maxlength,
                            'text-muted' : !f.Company_Postal_Code_N.errors?.maxlength
                            }">
                      {{ icdForm.get('Company_Postal_Code_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Postal_Code_N }}
                    </div>
                    <div *ngIf="submitted && f.Company_Postal_Code_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Postal_Code_N.errors.required">New_Postal_Code   is required</div>
                      <div *ngIf="f.Company_Postal_Code_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Company_Postal_Code_N }} characters allowed
                      </div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="row">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Owner_Office_Phone">Old Mobile Phone <code>*</code></label>
                    <input type="text" formControlName="Owner_Office_Phone" class="form-control"
                           [ngClass]="{'is-valid': f.Owner_Office_Phone.valid, 'is-invalid' : submitted && f.Owner_Office_Phone.valid}" placeholder="Enter  Mobile Phone "
                           appAiHint="Owner Office Phone" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Owner_Office_Phone.errors" class="invalid-feedback">
                      <div *ngIf="f.Owner_Office_Phone.errors.required">Mobile Phone   is required</div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone_N">New Mobile Phone </label>
                    <input type="text" formControlName="Owner_Mobile_Phone_N" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'elevenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Mobile_Phone_N"
                           placeholder="X-XXX-XXX-XXXX"
                           appAiHint="New Owner Mobile Phone" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{
       'text-danger': f.Owner_Mobile_Phone_N.errors?.maxlength,
       'text-muted': !f.Owner_Mobile_Phone_N.errors?.maxlength
     }">

                      {{ icdForm.get('Owner_Mobile_Phone_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Mobile_Phone_N }}

                    </div>
                    <div *ngIf="submitted && f.Owner_Mobile_Phone_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Owner_Mobile_Phone_N.errors.required">Mobile Phone   is required</div>
                      <div *ngIf="f.Owner_Mobile_Phone_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Owner_Mobile_Phone_N }} characters allowed
                      </div>
                      <div>Mobile phone must be 11 digits starting with 1 (country code).</div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Old Office Phone </label>
                    <input type="text" formControlName="Company_Office_Phone" class="form-control" 
                           [ngClass]="{'is-valid': f.Company_Office_Phone.valid, 'is-invalid' : submitted && f.Tax_ID.valid}"
                           placeholder="Enter  Office Phone"
                           appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
                   
                    <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
                      
                    </div>

                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Company_Office_Phone_N">New Office Phone </label>
                    <input type="text" formControlName="Company_Office_Phone_N" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Company_Office_Phone_N"
                           placeholder="XXX-XXX-XXXX"
                           appAiHint="New Company Office Phone" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{
  'text-danger': f.Company_Office_Phone_N.errors?.maxlength,
  'text-muted': !f.Company_Office_Phone_N.errors?.maxlength
}">

                      {{ icdForm.get('Company_Office_Phone_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Office_Phone_N }}

                    </div>
                    <div *ngIf="submitted && f.Company_Office_Phone_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Office_Phone_N.errors.required">Office Phone  is required</div>
                      <div *ngIf="f.Company_Office_Phone_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Company_Office_Phone_N }} characters allowed
                      </div>
                    </div>
                    

                  </div>
                </div>

              </div>
              <div class="row hide">


                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Sales_tax_perc">Old Sales Tax </label>
                    <input type="text" formControlName="Sales_tax_perc" class="form-control"
                           [ngClass]="{'is-valid': f.Sales_tax_perc.valid, 'is-invalid' : submitted && f.Sales_tax_perc.valid}" placeholder="Enter  old Sales Tax  "
                           appAiHint="Sales Tax Percentage" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Sales_tax_perc.errors" class="invalid-feedback">
                      <div *ngIf="f.Sales_tax_perc.errors.required">Old Sales Tax   is required</div>
                    </div>

                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="col-form-label  col-md-12" for="login-Sales_tax_perc_N">New Sales Tax  <code>*</code></label>
                    <input type="text" formControlName="Sales_tax_perc_N"
                           [ngClass]="{'is-valid': f.Sales_tax_perc_N.valid, 'is-invalid' : submitted && !f.Sales_tax_perc_N.valid}" class="form-control" [attr.maxlength]="fieldMaxLengths.Sales_tax_perc_N"
                           placeholder="Enter  New Sales Tax  "
                           appAiHint="New Sales Tax Percentage" [aiHintForm]="icdForm" />
                    <div class="text-right
                          small mt-1"
                         [ngClass]="{
                          'text-danger' : f.Sales_tax_perc_N.errors?.maxlength,
                            'text-muted' : !f.Sales_tax_perc_N.errors?.maxlength
                            }">
                      {{ icdForm.get('Sales_tax_perc_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Sales_tax_perc_N }}
                    </div>
                    <div *ngIf="submitted && f.Sales_tax_perc_N.errors" class="invalid-feedback">
                      <div *ngIf="f.Sales_tax_perc_N.errors.required">New Sales Tax   is required</div>
                      <div *ngIf="f.Sales_tax_perc_N.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Sales_tax_perc_N }} characters allowed
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-md-12">

                  <label class="col-form-label  col-md-12" for="login-Effective_Date">Effective Date <code>*</code></label>

                  <div class="col-md-4">
                    <div class="input-group date" id="reservationdate" data-target-input="nearest">
                      <input type="text" formControlName="Effective_Date" data-target="#reservationdate" autocomplete="off"
                             id="Effective_Date" placeholder="Select Date "
                             class="form-control" [ngClass]="{'is-valid': submitted && f.Effective_Date.valid, 'is-invalid' : submitted && !f.Effective_Date.valid}"
                             required
                             appAiHint="Effective Date" [aiHintForm]="icdForm"
                             />
                      <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                        <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                      </div>
                      <div *ngIf="submitted && f.Effective_Date.errors" class="invalid-feedback">
                        <div *ngIf="f.Effective_Date.errors.required">Date is required</div>
                        <div *ngIf="f.Effective_Date.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                        <div *ngIf="f.Effective_Date.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                      </div>


                    </div>
                  </div>



                </div>



              </div>



            </div>

          </div>





        </div>




        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              Documents  -  Provide Copies of the Following:
            </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">


              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label " for="isInsuranceRequired">Does the ICD want Herb Joy Enterprises to refer it to an insurance broker ? <code>*</code></label>
                  <select formControlName="isInsuranceRequired" class="form-control" (change)="ChangeIsInsurance()" [ngClass]="{ 'is-invalid': submitted && f.isInsuranceRequired.errors }">
                    <option value="" disabled>Please Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  <div *ngIf="submitted && f.isInsuranceRequired.errors" class="invalid-feedback">
                    <div *ngIf="f.isInsuranceRequired.errors.required">Is the ICD providing their own Insurance  is required</div>
                  </div>
                </div>

              </div>
              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_US_Certificate_of_Insurance">Certificate(s) of Insurance (if applicable)</label>
                  <input type="file"  formControlName="Attach_US_Certificate_of_Insurance" class="form-control"
                         [ngClass]="{'is-valid': f.Attach_US_Certificate_of_Insurance.valid && f.Attach_US_Certificate_of_Insurance.value, 'is-invalid' : submitted && !f.Attach_US_Certificate_of_Insurance.valid}" 
                         (change)="onFileSelected($event, 'Attach_US_Certificate_of_Insurance')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Certificate_of_Insurance' }"></ng-container>


                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Certificate_of_Insurance')">
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.required">Attach_US_Certificate_of_Insurance is required</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <div class="mt-1" *ngIf="verificationState['Attach_US_Certificate_of_Insurance']">
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                    <ul *ngIf="verificationIssues['Attach_US_Certificate_of_Insurance']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" style="list-style: disc;">
                      <li *ngFor="let issue of verificationIssues['Attach_US_Certificate_of_Insurance']">{{ issue }}</li>
                    </ul>
                  </div>


                </div>
              </div>

              <div class="col-sm-6 hide">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_Insurance_Application">Insurance Application </label>
                  <input type="file"  formControlName="Attach_Insurance_Application" class="form-control"
                         [ngClass]="{'is-valid': f.Attach_Insurance_Application.valid && f.Attach_Insurance_Application.value, 'is-invalid' : submitted && !f.Attach_Insurance_Application.valid}" 
                         (change)="onFileSelected($event, 'Attach_Insurance_Application')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Insurance_Application' }"></ng-container>


                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Insurance_Application')">
                    <div *ngIf="icdForm.get('Attach_Insurance_Application').errors.required">Attach_Insurance_Application is required</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Application').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Application').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Application').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>


                </div>
              </div>
              <div class="col-sm-6 hide">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Additional_Insurance_Questionnaire">Additional Insurance Questionnaire (if in seperate file)</label>
                  <input type="file" formControlName="Additional_Insurance_Questionnaire" class="form-control"
                         [ngClass]="{'is-valid': f.Additional_Insurance_Questionnaire.valid && f.Additional_Insurance_Questionnaire.value, 'is-invalid' : submitted && !f.Additional_Insurance_Questionnaire.valid}" 
                         (change)="onFileSelected($event, 'Additional_Insurance_Questionnaire')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Additional_Insurance_Questionnaire' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Additional_Insurance_Questionnaire')">
                    <div *ngIf="icdForm.get('Additional_Insurance_Questionnaire').errors.required">Additional_Insurance_Questionnaire is required</div>
                    <div *ngIf="icdForm.get('Additional_Insurance_Questionnaire').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Additional_Insurance_Questionnaire').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Additional_Insurance_Questionnaire').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-6 ">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Workers_Compensation">Proof of Worker's Compensation Coverage</label>
                  <input type="file" formControlName="Workers_Compensation" class="form-control"
                         [ngClass]="{'is-valid': f.Workers_Compensation.valid && f.Workers_Compensation.value, 'is-invalid' : submitted && !f.Workers_Compensation.valid}" 
                         (change)="onFileSelected($event, 'Workers_Compensation')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Workers_Compensation' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Workers_Compensation')">
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.required">Workers_Compensation is required</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-6 ">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-NY_and_HI_Disability_Form">NY and HI Disability Form</label>
                  <input type="file" formControlName="NY_and_HI_Disability_Form" class="form-control"
                         [ngClass]="{'is-valid': f.NY_and_HI_Disability_Form.valid && f.NY_and_HI_Disability_Form.value, 'is-invalid' : submitted && !f.NY_and_HI_Disability_Form.valid}" 
                         (change)="onFileSelected($event, 'NY_and_HI_Disability_Form')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'NY_and_HI_Disability_Form' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('NY_and_HI_Disability_Form')">
                    <div *ngIf="icdForm.get('NY_and_HI_Disability_Form').errors.required">NY_and_HI_Disability_Form is required</div>
                    <div *ngIf="icdForm.get('NY_and_HI_Disability_Form').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('NY_and_HI_Disability_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('NY_and_HI_Disability_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-6 hide">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-B_8822_Document">8822-B Document</label>
                  <input type="file" formControlName="B_8822_Document" class="form-control"
                         [ngClass]="{'is-valid': f.B_8822_Document.valid && f.B_8822_Document.value, 'is-invalid' : submitted && !f.B_8822_Document.valid}" 
                         (change)="onFileSelected($event, 'B_8822_Document')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'B_8822_Document' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('B_8822_Document')">
                    <div *ngIf="icdForm.get('B_8822_Document').errors.required">8822_B_Document is required</div>
                    <div *ngIf="icdForm.get('B_8822_Document').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('B_8822_Document').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('B_8822_Document').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>


              <div class="col-sm-6 hide">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_RAA">RAA Form</label>
                  <input type="file" formControlName="Attach_RAA" (change)="onFileSelected($event, 'Attach_RAA')"
                         [ngClass]="{'is-valid': f.Attach_RAA.valid && f.Attach_RAA.value, 'is-invalid' : submitted && !f.Attach_RAA.valid}" 
                         class="form-control" [class.is-invalid]="isInvalid('Attach_RAA')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_RAA' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_RAA')">
                    <div *ngIf="icdForm.get('Attach_RAA').errors.required">Articles of Incorporation/Organization is required</div>
                    <div *ngIf="icdForm.get('Attach_RAA').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_RAA').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_RAA').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

                </div>


              </div>
              <div class="col-sm-6" *ngIf="isLocation_out_state">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_Incorporation">Article of Incorporation/ State Qualification </label>
                  <input type="file" formControlName="Attach_Incorporation" (change)="onFileSelected($event, 'Attach_Incorporation')"
                         [ngClass]="{'is-valid': f.Attach_Incorporation.valid && f.Attach_Incorporation.value, 'is-invalid' : submitted && !f.Attach_Incorporation.valid}" 
                         class="form-control" [class.is-invalid]="isInvalid('Attach_Incorporation')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Incorporation' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Incorporation')">
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.required">Article of Incorporation/ State Qualification is required</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <div class="mt-1" *ngIf="verificationState['Attach_Incorporation']">
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                    <ul *ngIf="verificationIssues['Attach_Incorporation']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_Incorporation'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_Incorporation'] === 'warn'" style="list-style: disc;">
                      <li *ngFor="let issue of verificationIssues['Attach_Incorporation']">{{ issue }}</li>
                    </ul>
                  </div>
                  <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

                </div>

              </div>
              <div class="col-sm-6" *ngIf="isLocation_out_state">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_DBA_Doc">DBA Document</label>
                  <input type="file" formControlName="Attach_DBA_Doc" class="form-control" (change)="onFileSelected($event, 'Attach_DBA_Doc')"
                         [ngClass]="{'is-valid': f.Attach_DBA_Doc.valid && f.Attach_DBA_Doc.value, 'is-invalid' : submitted && !f.Attach_DBA_Doc.valid}" 
                         [class.is-invalid]="isInvalid('Attach_DBA_Doc')"  />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_DBA_Doc' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_DBA_Doc')">
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.required">DBA Document is required</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-6" *ngIf="isLocation_out_state">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_Renter_Insurance">Renter's/Home Owner's Insurance (If based out of house) </label>
                  <input type="file" formControlName="Attach_Renter_Insurance" class="form-control" (change)="onFileSelected($event, 'Attach_Renter_Insurance')"
                         [ngClass]="{'is-valid': f.Attach_Renter_Insurance.valid && f.Attach_Renter_Insurance.value, 'is-invalid' : submitted && !f.Attach_Renter_Insurance.valid}" 
                         [class.is-invalid]="isInvalid('Attach_Renter_Insurance')"  />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Renter_Insurance' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Renter_Insurance')">
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.required">Insurance  is required</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>






            </div>


            <h6>***</h6>
            <b>FORM MUST BE FULLY COMPLETED IN ORDER FOR COVERAGE TO BE CONSIDERED.  COVERAGE IS NOT BOUND UNTIL CONFIRMED BY INSURER</b>
            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
        <button type="button" class="btn btn-primary" (click)="saveSection5()">Save Docs</button>
      </div>-->
          </div>

        </div>




      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>
  </form>
</div>


